// Multilingual translations for Scanini
export const translations = {
  tn: {
    // Navbar
    nav: {
      home: "الرئيسية",
      services: "خدماتنا",
      about: "علينا",
      contact: "اتصل بنا",
    },
    // Hero Section
    hero: {
      tagline: "المستقبل الرقمي",
      title: "حوّل أعمالك للعالم الرقمي",
      subtitle: "نصنعلك قوائم و كتالوجات رقمية بتكنولوجيا QR Code",
      cta: "ابدأ الآن",
      ctaSecondary: "اكتشف خدماتنا",
    },
    // Services
    services: {
      title: "خدماتنا",
      subtitle: "حلول رقمية متكاملة لأعمالك",
      menu: {
        title: "قوائم رقمية",
        description: "قوائم طعام ذكية و تفاعلية، سهلة التحديث و صديقة للبيئة. زبائنك يشوفو القائمة بسكان بسيط.",
      },
      catalog: {
        title: "كتالوجات رقمية",
        description: "اعرض منتجاتك و خدماتك بطريقة احترافية. كتالوجات تفاعلية تخلي الزبون يعيش تجربة مميزة.",
      },
      qr: {
        title: "QR Code مخصص",
        description: "QR Codes مصممة خصيصا لعلامتك التجارية. تصميم احترافي يعكس هوية أعمالك.",
      },
      marketing: {
        title: "تسويق و إعلانات",
        description: "استراتيجيات تسويق رقمي فعالة. نسوقو لأعمالك على السوشيال ميديا و نوصلو لجمهورك.",
      },
    },
    // Features/Why Choose Us
    features: {
      title: "علاش تختار سكانيني؟",
      feature1: {
        title: "سرعة و كفاءة",
        description: "نخدمو بسرعة و نوفرو لك وقتك",
      },
      feature2: {
        title: "تصميم احترافي",
        description: "تصاميم عصرية و جذابة لزبائنك",
      },
      feature3: {
        title: "دعم مستمر",
        description: "فريقنا متاح باش يساعدك وقتما تحتاج",
      },
      feature4: {
        title: "أسعار تنافسية",
        description: "جودة عالية بأسعار معقولة",
      },
    },
    // Clients/Testimonials
    clients: {
      title: "عملاؤنا",
      subtitle: "يثقون فينا",
    },
    // About Us
    about: {
      title: "من نحن",
      description: "سكانيني هي شركة تونسية رائدة في مجال الحلول الرقمية. نتخصص في إنشاء قوائم و كتالوجات رقمية باستخدام تكنولوجيا QR Code، مما يساعد الأعمال على التحول الرقمي بسهولة و فعالية. فريقنا المحترف يقدم خدمات متكاملة من التصميم إلى التسويق الرقمي.",
      mission: "رؤيتنا",
      missionText: "نسعى لأن نكون الخيار الأول للأعمال التونسية في رحلة التحول الرقمي",
      vision: "مهمتنا",
      visionText: "تقديم حلول رقمية مبتكرة و بأسعار تنافسية لجميع الأعمال",
    },
    // Contact
    contact: {
      title: "اتصل بنا",
      subtitle: "احنا هنا باش نساعدوك",
      form: {
        name: "الاسم",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف",
        message: "رسالتك",
        submit: "أرسل",
        sending: "جاري الإرسال...",
      },
      info: {
        phone: "الهاتف",
        email: "البريد الإلكتروني",
      },
      whatsapp: "تواصل عبر واتساب",
    },
    // Footer
    footer: {
      tagline: "شريكك في التحول الرقمي",
      quickLinks: "روابط سريعة",
      followUs: "تابعونا",
      rights: "© 2026 Scanini. كل الحقوق محفوظة.",
    },
  },
  fr: {
    // Navbar
    nav: {
      home: "Accueil",
      services: "Services",
      about: "À propos",
      contact: "Contact",
    },
    // Hero Section
    hero: {
      tagline: "L'Avenir Numérique",
      title: "Transformez votre entreprise en numérique",
      subtitle: "Nous créons des menus et catalogues numériques avec la technologie QR Code",
      cta: "Commencer maintenant",
      ctaSecondary: "Découvrir nos services",
    },
    // Services
    services: {
      title: "Nos Services",
      subtitle: "Des solutions numériques complètes pour votre entreprise",
      menu: {
        title: "Menus Numériques",
        description: "Menus intelligents et interactifs, faciles à mettre à jour et écologiques. Vos clients accèdent au menu en un simple scan.",
      },
      catalog: {
        title: "Catalogues Numériques",
        description: "Présentez vos produits et services de manière professionnelle. Des catalogues interactifs pour une expérience client unique.",
      },
      qr: {
        title: "QR Code Personnalisé",
        description: "QR Codes conçus spécialement pour votre marque. Design professionnel reflétant l'identité de votre entreprise.",
      },
      marketing: {
        title: "Marketing & Publicité",
        description: "Stratégies de marketing digital efficaces. Nous promouvons votre entreprise sur les réseaux sociaux et atteignons votre audience.",
      },
    },
    // Features
    features: {
      title: "Pourquoi choisir Scanini?",
      feature1: {
        title: "Rapidité & Efficacité",
        description: "Service rapide pour optimiser votre temps",
      },
      feature2: {
        title: "Design Professionnel",
        description: "Designs modernes et attractifs pour vos clients",
      },
      feature3: {
        title: "Support Continu",
        description: "Notre équipe disponible quand vous en avez besoin",
      },
      feature4: {
        title: "Prix Compétitifs",
        description: "Haute qualité à prix abordables",
      },
    },
    // Clients/Testimonials
    clients: {
      title: "Nos Clients",
      subtitle: "Ils nous font confiance",
    },
    // About Us
    about: {
      title: "À Propos",
      description: "Scanini est une entreprise tunisienne leader dans les solutions numériques. Nous nous spécialisons dans la création de menus et catalogues numériques utilisant la technologie QR Code, aidant les entreprises à se transformer numériquement facilement et efficacement. Notre équipe professionnelle offre des services complets, du design au marketing digital.",
      mission: "Notre Vision",
      missionText: "Être le premier choix pour les entreprises tunisiennes dans leur transformation digitale",
      vision: "Notre Mission",
      visionText: "Fournir des solutions numériques innovantes à des prix compétitifs pour toutes les entreprises",
    },
    // Contact
    contact: {
      title: "Contactez-nous",
      subtitle: "Nous sommes là pour vous aider",
      form: {
        name: "Nom",
        email: "Email",
        phone: "Téléphone",
        message: "Votre message",
        submit: "Envoyer",
        sending: "Envoi en cours...",
      },
      info: {
        phone: "Téléphone",
        email: "Email",
      },
      whatsapp: "Contacter via WhatsApp",
    },
    // Footer
    footer: {
      tagline: "Votre partenaire de transformation numérique",
      quickLinks: "Liens rapides",
      followUs: "Suivez-nous",
      rights: "© 2026 Scanini. Tous droits réservés.",
    },
  },
  en: {
    // Navbar
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      contact: "Contact",
    },
    // Hero Section
    hero: {
      tagline: "The Digital Future",
      title: "Transform Your Business Digitally",
      subtitle: "We create digital menus and catalogs with QR Code technology",
      cta: "Get Started",
      ctaSecondary: "Discover Services",
    },
    // Services
    services: {
      title: "Our Services",
      subtitle: "Complete digital solutions for your business",
      menu: {
        title: "Digital Menus",
        description: "Smart and interactive menus, easy to update and eco-friendly. Your customers access the menu with a simple scan.",
      },
      catalog: {
        title: "Digital Catalogs",
        description: "Showcase your products and services professionally. Interactive catalogs for a unique customer experience.",
      },
      qr: {
        title: "Custom QR Code",
        description: "QR Codes designed specifically for your brand. Professional design reflecting your business identity.",
      },
      marketing: {
        title: "Marketing & Advertising",
        description: "Effective digital marketing strategies. We promote your business on social media and reach your audience.",
      },
    },
    // Features
    features: {
      title: "Why Choose Scanini?",
      feature1: {
        title: "Speed & Efficiency",
        description: "Fast service to optimize your time",
      },
      feature2: {
        title: "Professional Design",
        description: "Modern and attractive designs for your customers",
      },
      feature3: {
        title: "Continuous Support",
        description: "Our team available when you need help",
      },
      feature4: {
        title: "Competitive Pricing",
        description: "High quality at affordable prices",
      },
    },
    // Clients/Testimonials
    clients: {
      title: "Our Clients",
      subtitle: "They trust us",
    },
    // About Us
    about: {
      title: "About Us",
      description: "Scanini is a leading Tunisian company in digital solutions. We specialize in creating digital menus and catalogs using QR Code technology, helping businesses transform digitally easily and effectively. Our professional team provides comprehensive services from design to digital marketing.",
      mission: "Our Vision",
      missionText: "To be the first choice for Tunisian businesses in their digital transformation journey",
      vision: "Our Mission",
      visionText: "Deliver innovative digital solutions at competitive prices for all businesses",
    },
    // Contact
    contact: {
      title: "Contact Us",
      subtitle: "We're here to help you",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Your message",
        submit: "Send",
        sending: "Sending...",
      },
      info: {
        phone: "Phone",
        email: "Email",
      },
      whatsapp: "Contact via WhatsApp",
    },
    // Footer
    footer: {
      tagline: "Your digital transformation partner",
      quickLinks: "Quick Links",
      followUs: "Follow Us",
      rights: "© 2026 Scanini. All rights reserved.",
    },
  },
};

export const contactInfo = {
  email: "contact@scanini.tn",
  phone: "+216 24 890 403",
  whatsapp: "21624890403",
  social: {
    instagram: "https://www.instagram.com/scanini_qr/?hl=en",
    facebook: "https://www.facebook.com/profile.php?id=100089303477683",
  },
};
